import ComponentModal from "./ComponentModal";

export default ComponentModal;
